export const kgToLbs = (kg) => {
	return kg * 2.204623;
};
